import React, { useState, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { setLayoutFooter, setLayoutSubheader } from '../../../utils/layout';
import OrdersList from './components/OrdersList';
import { ListType } from './constatns';

const OrderListPage: React.FC = () => {
  const { type } = useParams();
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const tabFromUrl = queryParams.get('tab') as 'active' | 'completed' | 'all' | null;
  
  const [activeTab, setActiveTab] = useState<'active' | 'completed' | 'all'>(
    tabFromUrl || 'all'
  );
  
  useEffect(() => {
    if (tabFromUrl && ['active', 'completed', 'all'].includes(tabFromUrl)) {
      setActiveTab(tabFromUrl);
    } else if (type === 'active') {
      setActiveTab('active');
    } else if (type === 'completed') {
      setActiveTab('completed');
    } else {
      setActiveTab('all');
    }
  }, [type, tabFromUrl]);

  const handleTabClick = (tab: 'active' | 'completed' | 'all') => {
    setActiveTab(tab);
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set('tab', tab);
    navigate(`${location.pathname}?${newQueryParams.toString()}`, { replace: true });
  };

  setLayoutSubheader({
    title: intl.formatMessage({ id: 'SUBMENU.ALLORDERS' }),
    tabs: type === ListType.ABANDONED ? undefined : [
      {
        label: intl.formatMessage({ id: 'ORDER.TABS.ACTIVE' }),
        active: activeTab === 'active',
        onClick: () => handleTabClick('active'),
      },
      {
        label: intl.formatMessage({ id: 'ORDER.TABS.COMPLETED' }),
        active: activeTab === 'completed',
        onClick: () => handleTabClick('completed'),
      },
      {
        label: intl.formatMessage({ id: 'ORDER.TABS.ALL' }),
        active: activeTab === 'all',
        onClick: () => handleTabClick('all'),
      },
    ],
  });
  setLayoutFooter({ show: true });

  return <OrdersList type={type || ''} smallSendMsgBtn activeTab={activeTab} />;
};

export default OrderListPage;
